const en = {
  msg: {
    hello: "hello",
  },
  head: {
    donate: "Donate Now!",
    subscribe: "Subscribe!",
  },
  nav: {
    home: "Home",
    plan: "About the Scholarship",
    scholarship: "Scholarship Application",
    winning_student: "Awardees",
    q_a: "FAQ",
    donate: "Supporting Partners",
  },
  footer: {
    slogan: "Keep exercising weekly!",
  },
  btn_list: {
    want_apply: "I want to apply",
    want_dona: "I want to be a sponsor",
    learn_more: "Learn more",
    show_more: "Show more",
    browse_more: "Browse more",
    his_story: "Learn More",
    want_donor: "I want to be a sponsor",
  },
  // 首页
  home: {
    banner_tit: "The IHKSports Scholarship for Continuing Training",
    plan_tit: "Our Objectives",
    plan_con:
      'IHKSports is devoted to provide sports training of at least 60 hours for underprivileged students. To further assist outstanding IHKSports alumni, we have set up The IHKSports Scholarship for Continuing Training for them to keep on pursuing their goals and passion in sports.',
    // more: "了解更多",
    apply_require: "Eligibility",
    apply_con:
      "IHKSports graduates who are <a href='https://form.jotform.com/201342715232443' target='_blank'><font color='#108ee9'>members of the IHKSports Alumni Club</font></a> with at least 60 hours IHKSports training experience who fulfilled the following <b><u>financial AND non-financial criteria</u></b>, regardless of age, nationality, religion and ethnicity, are eligible to apply.",
    economic: "Financial criteria",
    condition_1:
      "From a household beneficiary of the Comprehensive Social Security Assistance (CSSA) Scheme; or",
    condition_2:
      "From a household beneficiary of the Working Family Allowance (WFA) Scheme; or",
    condition_3:
      "From a household beneficiary of the Working Family Allowance (WFA) Scheme; or",
    condition_4:
      "Live in poverty and referred by a registered social worker/an NGO",
    plan_con_tit: "Overview",
    plan_con_txt:
      "The Scholarship will disburse a maximum of HKD$4,800 for awardees in 14 months. The Scholarship can only be used for disbursing sports programme from other sports organizations/clubs including registered and accredited institutions other than those partnered with IHKSports.",
      time_line: [{
        title: "One month after submission of submission",
        content: "Conduct selection and interview; Notify awardees via phone or email",
        },
        {
            title: "Phase 1 ",
            content: "Awardees join their own sports trainings",
        },
        {
            title: "Within first four months since training begins",
            content: "Awardees submit required documents; details for first-phase Scholarship dispatchment will be announced directly to each awardee within 5 working days",
        },
        {
            title: "Phase 2",
            content: "Awardees continue their sports programme trainings",
        },
        {
            title: "Within 5th to 10th months since training begins",
            content: "Awardees subit required documents; details for first-phase Scholarship dispatchment will be announced directly to each awardee within 5 working days",
        },
      ],
      timeline: [
        'Look for your perferred sports training course and apply for the Scholarship',
        'Undergo selection and interview then wait for result anouncement in a month',
        'Successful applicants can register the course yourself and start training',
        'Submit required documents of the first phase online before the deadline and continue training',
        'Wait for IHKSports\'s approval and announcement after submitting documents on time',
        'Receive the First Phase\'s instalment',
        'Submit required documents of the last phase online before the deadline and continue training',
        'Second-phase dispatchment will be announced directly to each awardee',
        'Receive the Last Phase\'s instalment'
      ],
      timeline_title: [
        'Apply for Scholarship',
        'Wait for Result Announcement',
        'Register the course yourself',
        'Submit Documents',
        'Wait for IHKSports\' approval',
        'Receive the Instalment',
        'Submit Documents',
        'Wait for IHKSports\' approval',
        'Receive the Instalment'
      ],
      role_top: 'Elibible alumni',
      role_bottom: 'IHK Sports',
      phase1: 'First Phase (First 4 months of training)',
      phase2: 'Last Phase (Last 5- 14 months of training)',
      submit_deadline_text: 'Awardees are required to submit all relevant documents before the deadline. IHKSports will handle and dispatch scholarship instalments in three specific months every year for administrative convenience.',
      submit_deadline0: 'Deadline(s) of submitting all required documents',
      submit_deadline1: '15 March',
      submit_deadline2: '15 July',
      submit_deadline3: '15 November',
      release_month0: 'Month(s) of issuing scholarship instalments',
      release_month1: 'April',
      release_month2: 'August',
      release_month3: 'Decemeber',
    student_story_tit: "Our Story",
    student_story: [
      {
        name: "Lee Yi Yuet",
        imgPath: require("../../assets/img/home/student_2.png"),
        tit: "YOUnique! TAEKWONDO Primary (2018 - 2020)",
        con: `
        I come from a low-income family and I was diagnosed with a tendency of autism at a very young age. My parents wanted me to improve my communications and interpersonal skills so they encouraged me to join this taekwondo programme. At the beginning, I was very upset because I didn’t like making vigorous body contact with my classmates and I usually cry on my way home after class. Things got better and I started to enjoyed the classes as I become friends with my coach.<br><br>
There were a lot of difficulties along the way. Without the encouragement from my classmates and coach, I could not have come so far. There was a time when I needed to kick a wooden board during the belt assessment. I was afraid but my coach and classmates cheered me all the way and I successfully passed the test. There was another time when I didn’t want to join a taekwondo performance because I was scared that I could not perform well. But my coach reassured that I was capable of doing it. This gave me a huge confidence boost and we successfully pulled off some amazing moves and the audience enjoyed it a lot!<br><br>
I have a green belt at the moment. Even though I still think taekwondo is very challenging to me, I enjoyed being part of it. Since joining the programme, I manage my emotions better and I pretty enjoy interacting with others now. I really appreciate my coach, IHKSports and their sponsorships for the support and guidance along the way.
`,
        toLink:
          "https://paper.hket.com/article/2605211/%E8%B7%86%E6%8B%B3%E9%81%93%E6%95%99%E7%B7%B4%E4%BB%A5%E7%AB%A5%E5%BF%83%E6%95%99%E5%AD%B8%20%E8%AE%93SEN%E5%AD%B8%E7%AB%A5%E4%BA%AB%E5%8F%97%E9%81%8B%E5%8B%95",
      },
      {
        name: "Lam Chak Fung",
        imgPath: require("../../assets/img/home/student_1.png"),
        tit: "RUN Inspires! Secondary (2016 - 2018)",
        con: `I am grateful to have the opportunity to participate in the 10km distance running race in Gold Coast, Australia in 2018 under the sponsorship of IHKSports. I didn’t achieve my targeted time in the race but it has been a great lesson that inspires me up until today. I realized I am always competing against time in every aspects of life, whether it was the 15-hour flight delay, constant catch up in the race, or even holding onto the good times I spent in Australia… There are things that you have no control over life no matter how hard you try.<br><br>
        I really appreciate the support and guidance from my coach, Ka Ho. Right after I finished the race in Gold Coast, I was really devastated because I failed to live up to the expectations. I didn’t want to let others know the results and I didnt even dare to look at Ka Ho. However, Ka Ho came to me and said, “So Ping Tim didn’t run 9.9 seconds every time, there’s always some bad days in life.” I really want to thank him from the bottom of my heart because of his encouragement and kind words. Because of that I’m determined to keep on racing.<br><br>
        Not long after coming back to Hong Kong, I finally achieved my personal best in a local race. But after all this time, the sunshine in Gold Coast still outshines all the achievements that I’ve made. That was the best moment in my life. 
        `,
        toLink: "http://paper.wenweipo.com/2017/12/04/HS1712040018.htm",
      },
      {
        name: "Pun Hoi Lam",
        imgPath: require("../../assets/img/home/student_3.png"),
        tit: "CRICKET Inspires! Primary (2018 - 2020)",
        con: `I am a P5 student. I was invited by my PE coach and joined cricket training since P4. I had not heard of cricket before and I decided to give it a try out of curiosity. I was immediately hooked to this sport after trying it out. At the beginning, we lost a match because we were inexperienced and we weren’t that good either. Yet, we didn’t give up. Rather, we spent more time training even harder to improve our skills. After that I was even selected and invited to join the Cricket Youth Athletes Training Team. It was really exciting!<br><br>
        I had experienced an unforgettable match during IHKSports cricket training. We gave it all and fought until the last second. Eventually we won the match and a teammate who I was not too familiar with, came over to hug and congratulate me for the win. It was pretty surprising yet comforting as I finally knew what a “team” actually means to me. It isn’t about myself, it’s about everybody giving their all for the team to fight for goals together.<br><br>
        I want to take this opportunity to thank IHKSports and my coach for making this happen. My coach has taught me far more than just cricket skills.He taught me how to manage my emotions. Also, I’d like to thank my PE teacher, Mr. Tsui, for introducing me into this sport. And of course, I want to thank my mom because she accompanies me from Tung Chung to Causeway Bay for cricket training every week. Without her, I definitely could not have come this far!
        `,
        toLink:
          "https://www.sundaykiss.com/432406/%e7%86%b1%e8%a9%b1/%e6%9d%bf%e7%90%83-%e6%bd%9b%e8%83%bd-%e5%85%b1%e8%9e%8d-%e5%8b%87%e6%b0%a3-%e6%85%8b%e5%ba%a6/",
      },
    ],
  },
  // 計劃內容
  plan: {
    banner_tit: [
      "IHKSports is devoted to provide sports training of at least 60 hours for underprivileged students. To further assist outstanding IHKSports alumni,",
      "we have set up The IHKSports Scholarship for Continuing Training for them to keep on ",
      "pursuing their goals and passion in sports",
    ],
    eligibility: {
      con:
        "IHKSports graduates who are <a href='https://form.jotform.com/201342715232443' target='_blank'><font color='#108ee9'>members of the IHKSports Alumni Club</font></a> with at least 1-year 60 hours IHK Sports training experience (All district-based projects, WELL DUNK!, Jockey Club InspiringHK SportsCHAT! SHE Inpsires!, The Home Run Programme supported by Link Together Initiatives), and who will NOT join IHKSports programme for the coming year and fulfilled the following <b><u>financial AND non-financial criteria</u></b>, regardless of age, nationality, religion and ethnicity, are eligible to apply.",
        financial_tit:
        "Financial criteria (finance/income certificate required): ",
      financial: [
        "From a household beneficiary of the Comprehensive Social Security Assistance (CSSA) Scheme; or",
        "Be a beneficiary of the School Textbook Assistance (TA) Scheme; or",
        "From a household beneficiary of the Working Family Allowance (WFA) Scheme; or",
        "Live in poverty and referred by a registered social worker/an NGO",
      ],
      non_financial_tit: "And non-financial criteria:",
      non_financial: [
        "Applicants have shown outstanding sports performance or potential in IHKSports classes；",
        "excellent attendance record；",
        "good communications skills and proactivity and",
        "eargerness to improve.",
      ],
      tips:
        "Only for those who finished IHKSports programme and those who will NOT join advanced IHKSports programme for the following year.",
    },
    content_plan: {
      title: "Overview",
      content: "The Scholarship will disburse a maximum of HKD$4,800 for awardees in 60 hours. The Scholarship  can only be used for disbursing regular sports programme ^ from other sports organizations/clubs (including registered and accredited institutions other than those partnered with IHKSports).",
      tips:"^Regular programmes are those which provide regular training every week/ month.",
      content_item: [
        `Priorities will be given to alumni who will pick the sports 
        option that is the same with or relevant to the sports programme as they took in IHKSports.`,
        `The Scholarship can only be used for subsidizing applicants’ programme 
        or coach fees, excluding the fees for sports gear or other purposes.`,
        `IHKSports alumni can be awarded with this scheme only once. 
        Awardees cannot apply for this Scholarship anymore.`,
        `The maximum amount is HK$4,800, but awardees
         can still apply for sports programme with costs over this limit.`,
      ],
    },
    details_plan: {
      title: "Details",
      content_item: [
          "Applications are accepted on a rolling basis all year around.",
          "The maximum of the Scholarship is HK$4,800 and will be disbursed in two phases. The first-phase Scholarship will not exceed <b><u>HK$1,600</b></u>. The last-phase Scholarship will not exceed <b><u>HK$3,200</b></u>. Total Scholarship will not exceed HK$4,800 in any circumstances.",
          "<b><u>Phase 1 (first four months since training begins)</b></u>: After the scholarship results are announced, awardees should upload all required documents to this website before the deadline:",
          "1. All programme receipts within this period",
          "2. Certificate of attendance (The dates of attended classes and signatures from coach should be shown)",
          "3. 3-4 class photos (At least one photo can clearly show the face of the applicant during the class.)",
          "If all relevant documents are provided, awardees will be invited to IHKSports office to collect the Scholarship subsidy of this period.",
          "<b><u>Last Phase (the 5th to 14th months since training begins)</b></u>: Awardees should upload all required documents to this website before the deadline:",
          "1. All programme receipts within this period (Course name, training days and schedule should be clearly displayed)",
          "2. Learning report (Share about one’s training experiences and personal changes after participation)",
          "3. Certificate of completion",
          "4. 3-4 class photos (At least one photo can clearly show the face of the applicant during the class.)",
          "If all relevant documents are provided, awardees will be invited to IHKSports office to collect the Scholarship subsidy of this period",
          "Results will be announced to applicants individually within a month after submission of applications. If no forms of notifications are received from IHKSports within two weeks after interview,  the application can be deemed as unsuccessful. If awardees cannot be contacted, or fail to submit relevant documents or certificates before the deadline, IHKSports has the right not to dispatch the current and remaining subsidies.",
          "The Scholarship will be dispatched in cash cheques on a reimbursement basis.",
      ],
  },
    responsibilities_plan: {
      title: "Awardees’ Responsibilities",
      content_item: [
        "Keep all programme receipts for reimbursement purpose,",
        "Submit all required documents on time",
        "Attend at least two events organised by IHKSports, including but not limited to physical activities or networking events,",
        "Conduct a sharing or perform in front of our current students at community centres or schools",
      ],
    },
  },
  // 奖学金申请
  scholarship: {
    time_tit: "Application Procedures",
    test_span:"To be announced.",
    plan_tit: "Plan summary",
    time_line: [{
          title: "One month after submission of submission",
          content: "Conduct selection and interview; Notify awardees via phone or email",
      },
      {
          title: "Phase 1 ",
          content: "Awardees join their own sports trainings",
      },
      {
          title: "Within first four months since training begins",
          content: "Awardees submit required documents; details for first-phase Scholarship dispatchment will be announced directly to each awardee within 5 working days",
      },
      {
          title: "Phase 2",
          content: "Awardees continue their sports programme trainings",
      },
      {
          title: "Within 5th to 10th months since training begins",
          content: "Awardees subit required documents; details for first-phase Scholarship dispatchment will be announced directly to each awardee within 5 working days",
      },
    ],
    timeLines_Detail: [
      {
        expand: false,
        phase: "Batch 1",
        info: [
          {
            year: "2020",
            info: [
              {
                month: "November",
                content: "20/11 Application deadline",
              },
              {
                month: "November",
                content: "26/11 Finish selection and interview",
              },
              {
                month: "November",
                content:
                  "27/11 or before Release of results (We will notify successful applicants directly by phone or email)",
              },
              {
                month: "December",
                content:
                  "Awardees joining related sports training (First Phase)",
              }
              // {
              //   month: "December",
              //   content:
              //     "31/12 or before Submission of required document (programme receipts of sports programme joined during first phase and corresponding certificate of attendance*), details for first-phase Scholarship dispatchment will be announced directly to each awardee within 5 working days",
              //   tips:
              //     "*Dates of class attended and coach signature are required",
              // },
            ],
          },
          {
            year: "2021",
            info: [
              {
                month: "March",
                content:
                  "31/3 or before Submission of required document (programme receipts of sports programme joined during first phase and corresponding certificate of attendance*), details for first-phase Scholarship dispatchment will be announced directly to each awardee within 5 working days *Dates of class attended and coach signature are required",
                tips:
                  "*Dates of class attended and coach signature are required",
              },
              {
                month: "April to September",
                content:
                  "Awardees to continue their sports programme training (second phase)",
              },
              {
                month: "September",
                content:
                  "31/9 or before Submission of learning report and required documents (programme receipts of sports programme joined during second phase and corresponding certificate of attendance*)",
                tips:
                  "*Dates of class attended and coach signature are required",
              },
              {
                month: "October",
                content:
                  "IHKSports Prize Presentation Ceremony and dispatchment of the second phase Scholarship",
              },
            ],
          },
        ],
      },
      {
        expand: false,
        phase: "Batch 2",
        info: [
          {
            year: "2021",
            info: [
              {
                month: "April",
                content: "30/4 Application deadline",
              },
              {
                month: "May",
                content: "31/5 Finish selection and interview",
              },
              {
                month: "June",
                content:
                  "5/6 Release of results (We will notify successful applicants directly by phone or email)",
              },
              {
                month: "June to September",
                content:
                  "Awardees joining related sports training (first phase)",
              },
              {
                month: "September",
                content:
                  "30/9 or before Submission of required documents (programme receipts of sports programme joined during first phase and corresponding certificate of attendance*), details for first-phase Scholarship dispatchment will be announced directly to each awardee within 5 working days",
                tips:
                  "*Date of classes attended and coach signature are required",
              },
              {
                month: "October to December ",
                content:
                  "Awardees to continue their sports training programme (second phase)",
              },
            ],
          },
          {
            year: "2022",
            info: [
              {
                month: "January to March",
                content:
                  "Awardees to continue their sports training programme (second phase)",
              },
              {
                month: "March",
                content:
                  "31/3 or before Submission of learning report and required documents (programme receipts of sports programme joined during second phase and corresponding attendance testimonial*)",
                tips:
                  "*Date of classes attended and coach signature are required",
              },
              {
                month: "April",
                content:
                  "IHKSports Prize Presentation Ceremony and dispatchment of second phase Scholarship",
              },
            ],
          },
        ],
      },
    ],
    other_tips: [
      "Application is accepted on a rolling basis all year around and quota is limited. Eligible IHKSports alumni can apply for this Scholarship through our online system.<br><br>",
      "Required documents for application: 1) IHKSports Graduation Certificate, 2) details of sports programme to be applied and 3) relevant financial certificate.<br><br>",
      "If you have any other supporting document(s), for example, reference letter from coach or sports videos of applicant, please submit it (them) with the application form.<br><br>",
      "Applicants shall read carefully the terms and conditions of the Scholarship before proceeding.<br><br>",
    ],
    other_btn:'Apply Now!'
  },
  // 歷屆得獎者
  awardees: {
    title: "Past awardees",
    tips:'Results to be announced.',
    period: ["Phase I", "Phase II"],
    peopleInfo: [
      {
        name: "Lam Chak Fung",
        source: "RUN Inspires! Secondary (2016 - 2018)",
        photo: require("../../assets/img/winning/dummy1.png"),
        story: "http://paper.wenweipo.com/2017/12/04/HS1712040018.htm",
      },
      {
        name: "Pun Hoi Lam",
        source: "CRICKET Inspires! Primary (2018 - 2020)",
        photo: require("../../assets/img/winning/dummy2.png"),
        story:
          "https://www.sundaykiss.com/432406/%e7%86%b1%e8%a9%b1/%e6%9d%bf%e7%90%83-%e6%bd%9b%e8%83%bd-%e5%85%b1%e8%9e%8d-%e5%8b%87%e6%b0%a3-%e6%85%8b%e5%ba%a6/",
      },
      {
        name: "Lee Yi Yuet",
        source: "YOUnique! TAEKWONDO Primary (2018 - 2020)",
        photo: require("../../assets/img/winning/dummy3.png"),
        story:
          "https://paper.hket.com/article/2605211/%E8%B7%86%E6%8B%B3%E9%81%93%E6%95%99%E7%B7%B4%E4%BB%A5%E7%AB%A5%E5%BF%83%E6%95%99%E5%AD%B8%20%E8%AE%93SEN%E5%AD%B8%E7%AB%A5%E4%BA%AB%E5%8F%97%E9%81%8B%E5%8B%95",
      },
      {
        name: "Pun Hoi Lam",
        source: "CRICKET Inspires! Primary (2018 - 2020)",
        photo: require("../../assets/img/winning/dummy4.png"),
        story:
          "https://www.sundaykiss.com/432406/%e7%86%b1%e8%a9%b1/%e6%9d%bf%e7%90%83-%e6%bd%9b%e8%83%bd-%e5%85%b1%e8%9e%8d-%e5%8b%87%e6%b0%a3-%e6%85%8b%e5%ba%a6/",
      },
    ],
    submin_tit: "Report Submission",
    submin_per: "Batch 1",
    submit: [
      {
        tit: "First Phase (first four months since training begins)",
        con: "Awardees shall submit all required documents. Documents handed in after the deadline will not be considered.",
        con_tit:"Please prepare the followings:",
        con_txt1:"All programme receipts within this period",
        con_txt2:"Certificate of attendance (The dates of attended classes and signatures from coach should be shown)",
        con_txt3:"3-4 class photos (At least one photo can clearly show the face of the applicant during the class.)",
        btn: "Submission",
        toLink: "https://form.jotform.me/201272049184451",
      },
      {
        tit: "Last Phase (the 5th to 14th months since training begins)",
        con: "Awardees should submit all required documents. Documents handed in after the deadline will not be considered.",
        con_tit:"Please prefer the followings:",
        con_txt1:"All programme receipts within this period",
        con_txt2:"Learning report (Share about one’s training experiences and personal changes after participation)",
        con_txt3:"Certificate of completion",
        con_txt4:"3-4 class photos (At least one photo can clearly show the face of the applicant during the class.)",
        btn: "Submission",
        toLink: "https://form.jotform.me/201272348215448",
      },
    ],
  },
  // 常見問題
  q_a: {
    question8_content: 'The Scholarship will be issued in two instalments:<br>\
    First phase (first four months since training begins): After the scholarship results are announced, awardees should upload all required documents to this website before the deadline:<br>\
    1. All programme receipts within this period<br>\
    2. Certificate of attendance (The dates of attended classes and signatures from coach should be shown)<br>\
    3. 3-4 class photos (At least one photo can clearly show the face of the applicant during the class.)<br>\
    If all relevant documents are provided, awardees will be invited to IHKSports office to collect the Scholarship subsidy of this period.<br><br>\
    Last phase (the 5th to 14th months since training begins): Awardees should upload all required documents to this website before the deadline:<br>\
    1. All programme receipts within this period<br>\
    2. Learning report (Share about one’s training experiences and personal changes after participation)<br>\
    3. Certificate of completion<br>\
    4. 3-4 class photos (At least one photo can clearly show the face of the applicant during the class.)<br>\
    If all relevant documents are provided, awardees will be invited to IHKSports office to collect the Scholarship subsidy of this period.<br><br>',
    banner_title: "",
    contant_title: "Scholarship Q&A",
    questions: [
      {
        tips:
          "Where can I get the latest information regarding The IHKSports Scholarship for Continuing Training?",
        answer: "You can get the latest update on this website.",
        expandStatus: true,
      },
      {
        tips: "Who are eligible for this Scholarship?",
        answer:
          "IHKSports graduates who are <a href='https://form.jotform.me/201342715232443' target='blank'><font color='#108ee9'>members of the IHKSports Alumni Club</font></a> with at least 1-year 60 hours IHK Sports training experience (All district-based projects, WELL DUNK!, Jockey Club InspiringHK SportsCHAT! SHE Inpsires!, The Home Run Programme supported by Link Together Initiatives), and who will NOT join IHKSports programme for the coming year and fulfilled the following <b><u>financial AND non-financial criteria</u></b>, regardless of age, nationality, religion and ethnicity, are eligible to apply.",
          contentItem2: {
          title: "Financial criteria (finance/income certificate required): ",
          lis: [
            "From a household beneficiary of the Comprehensive Social Security Assistance (CSSA) Scheme; or",
            "Be a beneficiary of the School Textbook Assistance (TA) Scheme; or",
            "From a household beneficiary of the Working Family Allowance (WFA) Scheme; or",
            "Live in poverty and referred by a registered social worker/an NGO",
          ],
        },
        contentItem3: {
          title: "And non-financial criteria:",
          content:
            "Applicants have shown outstanding sports performance or potential in IHKSports classes, excellent attendance record, good communications skills and proactivity and eargerness to improve. ",
        },
        contentItem4:
          "Only for those who finished IHKSports programme and those who will NOT join advanced IHKSports programme.",
        expandStatus: true,
      },
      {
        tips: "When can I apply?",
        answer:
          "Applications are accepted on a rolling basis all year around. Quotas are limited.",
        expandStatus: true,
      },
      {
        tips: "How can I use the Scholarship?",
        answer: `The Scholarship can only be used for subsidizing applicants’ sports programme fees 
          (including registered and accredited institutions other than those partnered with IHKSports),
           excluding fees for sports gear or other purposes. Priorities will be given to alumni who will 
           apply the same sports programme as they took in IHKSports.`,
        contentItem4: "<br>The subsidized sports programme should take place in 5-14 consecutive months.",
        expandStatus: true,
      },
      {
        tips: "How can I apply?",
        answer:
          "Eligible sports programme graduates can complete the application form on IHKSports website.",
        expandStatus: true,
      },
      {
        tips: "What documents are required?",
        answer:
          "Applicants should submit: 1) IHKSports testimonial, 2) information of sports programme to be applied and 3) finance certificate. Awardees have to keep the programme receipt for application use.",
        expandStatus: true,
      },
      {
        tips: "When will the results be released?",
        answer:
          "Results will be released via phone or email within a month after submission of application.",
        expandStatus: true,
      },
      {
        tips: "When will the Scholarship be issued?",
        answer:
          "Awardees are required to submit all relevant documents before the deadline. IHKSports will handle and dispatch scholarship instalments in three specific months every year for administrative convenience.",
          contentItem4:"If awardees cannot be contacted, or fail to submit all relevant documents or certificates before the deadline, IHKSports has the right not to dispatch the current and remaining subsidies.",
          expandStatus: true,
      },
      {
        tips:
          "What if the alumni cannot afford phase one sports programme fees at all?",
        answer:
          "Please let IHKSports know any special requests during the interview. IHKSports will take special circumstances into account.",
        expandStatus: true,
      },
      {
        tips: "What is the maximum amount of the Scholarship?",
        answer:
          "The maximum amount is HK$4,800, but awardees can still apply for sports programme with costs over this limit. The Scholarship will be dispatched in two instalments every year. The first-phase Scholarship will not exceed HK$1,600. The last-phase Scholarship will not exceed HK$3,200. Total Scholarship will not exceed HK$4,800 in any circumstances.",
        expandStatus: true,
      },
      {
        tips: "How will the Scholarship be dispatched?",
        answer:
          "The Scholarship will be dispatched in cash cheques on a reimbursement basis.",
        expandStatus: true,
      },
      {
        tips: "What is the selection process?",
        answer:
          "Applicants should submit an online application. IHKSports will invite shortlisted candidates for an interview by phone or email (to be confirmed). An independent selection committee comprised of IHKSports representatives, alumni and coaches will review all applications and formulate Scholarshiping decisions for each application. After the selection process, awardees will be notified by phone or email. Applicants who have not received a call, email or any form of notification two months after the interview may assume their applications unsuccessful.",
        expandStatus: true,
      },
      {
        tips: "How many times can I apply for the Scholarship?",
        answer:
          "IHKSports alumni can receive the Scholarship only once. Awardees cannot apply for this Scholarship anymore. ",
        expandStatus: true,
      },
      {
        tips: "What are the responsibilities of awardees?",
        answer: `Awardees are required to 
          1) keep all programme receipts for reimbursement purpose, 
          2) attend the IHKSports Prize Presentation Ceremony,
          3) attend at least two events organised by IHKSports with their assigned mentors, including but not limited to physical activities or networking events,
          4) conduct a sharing or perform in front of our current students at community centres or schools`,
        expandStatus: true,
      },
    ],
    other_questions:"Should you have further questions, please contact Miss Yau at 560 560 13 or <a href='mailto:alumni@inspiringhk.org' target='blank'><font color='#108ee9'>alumni@inspiringhk.org</font></a>.",
    hot_line:"Hotline +852 560 560 13"
  },
   // 合作夥伴
   supportpartners: {
    banner_title: "Supporting Partners",
    tit1:'List of Sponsors',
    con1:'We appreciate all sponsors’/ companies’/ organizations’ support.',
    donors_tit:'Founding Sponsorship',
    donors_data:['Sau Ching Charity Foundation Limited'],
    support_order: [
      {
        tit: "How to sponsor?",
        con:
          "To develop this Scholarship programme, your support means a lot to us. We hope that community members continue to back us in order to encourage our alumni to join long-term training so that they can unleash their potential and achieve their goals. Contributions of any amount are welcome. Each alumni can receive a maximum of HK$4,800, so for a donation of HK$4,800 or above, you may name the award after a person, a company or an organization. Interested parties may deposit to our bank account, use a crossed cheque, PayMe or PayPal and fill in the designated form.",
      },
      {
        tit: "Policy of Refunding",
        con:
          "Once the online donation is confirmed, it cannot be cancelled and no refund will be given. Please confirm the donation amount before transferring.",
      }
    ],
    btn_content: "Sponsor Now!",
    dona_methods: [
      {
        tit: "<u>Donate using PayPal</u>",
        con: "Please go to the <a href='https://donation.inspiringhk.org/eng/campaigns/view/3' target='blank'><font color='#108ee9'>donation page</font></a> and choose “Donate Online” to fill in the designated form.",
      },
      {
        tit: "<u>Deposit to bank account, use crossed cheque or PayMe</u>",
        con:
          "Please donate according to the <a href='https://donation.inspiringhk.org/' target='blank' style='color:#108ee9;'>instructions</a> on the webpage and keep the receipt or transfer record. Please fill in the <a href='https://form.jotform.com/201622278649056' target='blank' style='color:#108ee9;'>online form</a> and upload the donation record.",
      },
      // {
      //   tit: "贊助凝動持續運動訓練獎學金",
      //   con:
      //     "有意贊助獎學金者可透過銀行入賬、劃線支票、PayMe或PayPal的方式捐款，並填妥捐款表格［link］。本會職員稍後會儘快聯絡捐款人或機構再作跟進。",
      // },
    ],
  },
  // 立即申请
  scholarshipapplytips:{
    title:'Apply Now!',
    other_tips: [
      "Eligible IHKSports alumni can apply for this Scholarship through our online system on or before 20 November 2020.",
      "Required documents for application: 1) IHKSports Graduation Certificate, 2) details of sports programme to be applied and 3) relevant financial certificate.",
      "If you have any other supporting document(s), for example, reference letter from coach or sports videos of applicant, please submit it (them) with the application form.",
      "Applicants shall read carefully the terms and conditions of the Scholarship before proceeding.",
    ],
    sxTip:"**Please be reminded not to submit your application at the very last minute and you should allow sufficient time for uploading. Late submission will not be entertained.**"
  },
  externalsportsprogrammes:{
    tit:'Reference List of External Sports Programmes',
    conlist:[
      '1. 以下名單僅供合資格的凝動舊生申請「凝動持續運動訓練獎學金」時作參考之用，並不代表本會推薦名單上的課程。',
      '2. 請留意獎學金所涵蓋的課程不限名單上的課程，舊生可以參加坊間其他具商業登記證明的體育培訓機構或球會舉辦之體育常規課程。',
      '3. 任何有關課程的內容、更新及改動，舊生及家長應向教練或有關團體查詢及了解最新情況，以課程主辦單位公佈的資訊為準，名單僅作參考。',
      '4. 有關獎學金詳情，請瀏覽<font color="#2191d0"><a href="http://trainingfund.inspiringhk.org/#/overview" target="_blank">本會網頁</a></font>。',
    ],
    btn:'按此查看參考名單'
  }
};

export default en;
